import { useState } from 'react';
import Header from './layout/Header';
import Left from './layout/Left';
import Content from './layout/Content';
import MatrixViewer from './MatrixViewer/MatrixViewer';
import { CacheLayout } from './ConfigCache/CacheLayout';

const Layout = ({ children }) => {
  const [tab, setTab] = useState('rules');

  const handleSetTab = (tab) => {
    setTab(tab);
  };

  return (
    <div className="flex flex-col h-screen w-screen">
      <Header tab={tab} onTabClick={handleSetTab} />
      {tab === 'rules' && (
        <div className="flex flex-row h-screen">
          <Left />
          <Content>{children}</Content>
        </div>
      )}
      {tab === 'matrix' && <MatrixViewer />}
      {tab === 'cache' && <CacheLayout />}
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;